<template>
  <div class="nav-content">
    <div class="nav">
      <div class="middle">
        <div><router-link to="/Home">{{ $t('home') }}</router-link><span class="line"></span></div>
        <div><router-link to="/Feature">{{ $t('features') }}</router-link><span class="line"></span></div>
        <div><router-link to="/Prices">{{ $t('pricing') }}</router-link><span class="line"></span></div>
        <!--<div><router-link to="/Resource">{{ $t('resources') }}</router-link></div>-->
        <!--<div><a href="https://openapi.bat.chat" target="_blank">{{ $t('openapi') }}</a></div>-->
        <!--<div><router-link to="/Contact">{{ $t('contact') }}</router-link></div>-->
        <!--<div><router-link to="/serversupport">Service & Support</router-link></div>-->
        <div><a href="https://dl.craitcorp.com" target="_blank">{{ $t('download') }}</a><span class="line"></span></div>
        <!--<div><router-link to="/about">About Us</router-link></div>-->
      </div>
      <!--<div class="right"><a href="/login/index.html" target="_blank">Login</a></div>-->
    </div>
    <el-popover
      ref="popover"
      placement="bottom"
      width="160"
      trigger="hover">
      <ul class="login-box">
        <li @click="openLoginPage" class="hover-blue">{{ $t('CraitForWeb') }}</li>
        <li @click="openBackPanel" class="hover-blue">{{ $t('console') }}</li>
      </ul>
    </el-popover>
    <!-- <div class="login">{{ $t('login') }}</div> -->
    <el-button class="login" v-popover:popover>{{ $t('login') }}</el-button>
    <div class="location" @click="showCountryList">
      <img :src="localeLanguageObj.src" alt="">
      <span>{{localeLanguageObj.label}}</span>
      <img src="../assets/images/20180827/arrow.png" alt="">
      <!--<div class="location-line"></div>-->
    </div>
    <transition name="my-country-list">
      <ul class="country-list" v-show="countryListShow" transition="my-country-list" ref="country-list">
        <li v-for="(item, key) in items" :data-value="item.value" v-show="item.value !== localeLanguage" @click="toggleCountry(item.value)">
          <img :src="item.src" alt="">
          <span>{{item.label}}</span>
        </li>
        <!--<li>-->
          <!--<img src="../assets/images/20180827/china.png" alt="">-->
          <!--<span>繁體中文</span>-->
        <!--</li>-->
        <!--<li>-->
          <!--<img src="../assets/images/20180827/English.png" alt="">-->
          <!--<span>English</span>-->
        <!--</li>-->
        <!--<li>-->
          <!--<img src="../assets/images/20180827/spa.png" alt="">-->
          <!--<span>Español</span>-->
        <!--</li>-->
        <!--<li>-->
          <!--<img src="../assets/images/20180827/rus.png" alt="">-->
          <!--<span>россия</span>-->
        <!--</li>-->
      </ul>
    </transition>
  </div>
</template>

<script>
import { responsiveNav } from '../assets/js/responsive-nav.js'
import '../assets/css/responsive-nav.css'

export default {
  name: 'nav',
  data () {
    return {
      navigation: {},
      items: {
        cn: {
          label: '简体中文',
          src: require('../assets/images/20180827/china.png'),
          value: 'cn'
        },
        td: {
          label: '繁體中文',
          src: require('../assets/images/20180827/hk.png'),
          value: 'td'
        },
        en: {
          label: 'English',
          src: require('../assets/images/20180827/English.png'),
          value: 'en'
        },
        spa: {
          label: 'Español',
          src: require('../assets/images/20180827/spa.png'),
          value: 'spa'
        },
        rus: {
          label: 'россия',
          src: require('../assets/images/20180827/rus.png'),
          value: 'rus'
        }
      },
      localeLanguage: '',
      localeLanguageObj: {},
      countryListShow: false,
      itemsCopy: {}
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (localStorage.getItem('localeLanguage')) {
        this.localeLanguage = localStorage.getItem('localeLanguage')
        this.localeLanguageObj = this.items[localStorage.getItem('localeLanguage')]
//      this.itemsCopy = JSON.parse(JSON.stringify(this.items))
//      delete this.items[localStorage.getItem('localeLanguage')]
      }
    })
    this.navigation = responsiveNav('.nav', {
      animate: true,
      transition: 400,
      label: '···',
      insert: 'before',
      customToggle: '',
      closeOnNavClick: true,
      openPos: 'relative',
      navClass: 'nav-collapse',
      navActiveClass: 'js-nav-active',
      jsClass: 'js',
      init: function () {},
      open: function () {},
      close: function () {}
    })
  },
  methods: {
    openLoginPage () {
      window.open('/login/index.html')
    },
    openBackPanel () {
      window.open('/backpanel/index.html')
    },
    initCountry (preLan, curLan) {
      let preCountry = this.itemsCopy[preLan]
      delete this.items[curLan]
      this.items[preLan] = preCountry
    },
    showCountryList () {
      this.countryListShow = !this.countryListShow
    },
    toggleCountry (lan) {
      if (lan) {
        localStorage.setItem('localeLanguage', lan)
        this.localeLanguage = lan
        this.localeLanguageObj = this.items[lan]
//        this.initCountry(this.$i18n.locale, lan)
        this.$i18n.locale = lan
      }
      this.countryListShow = false
    }
  }
}
</script>

<style lang="scss">
.nav {
  position: absolute;
  top: 0;
  bottom: 0;
  right:0;
  left: 385px;
  /*text-align: left;*/
  /*float: right;*/
  @media screen and (max-width: 1700px) {
    left: 240px;
    @media screen and (max-width: 760px) {
      float: inherit;
      left: 0;
      text-align: center;
    }
  }
  .middle {
    display: inline-block;
    line-height: 0.6rem;
    // display: flex;
    // justify-content: space-around;
    div {
      float: left;
      /*padding-left: 0.05rem;*/
      margin-right: 60px;
      @media screen and (max-width: 1440px) {
        margin-right: 30px;
      }
      &:hover a{
        /*color: #5ea2ec*/
      }
      a {
        /*padding: 0.08rem;*/
        /*border-radius: 0.05rem;*/

        &.router-link-active, &.router-link-exact-active {
          background: transparent;
          color: #5ea2ec;
        }
        &.router-link-active + .line {
          display: block;
          min-width: 50px;
          height: 4px;
          background: #5ea2ec;
          margin-top: 4px;
          /*margin-left: 5px;*/
          @media screen and (max-width: 760px) {
            display: none;
          }
        }
      }

      /*&::after {*/
        /*content: '|';*/
        /*color: #fff;*/
        /*padding-left: 0.066rem;*/
      /*}*/

      &:last-child::after {
        content: '';
      }
    }
    div:last-child {
      margin: 0;
    }
    &::after {
      content: '';
      overflow: hidden;
      clear: both;
      display: table;
      font-size: .1rem
    }
    /*.line {
      display: block;
      width: 50px;
      height: 4px;
      background: #5ea2ec;
      margin-top: -7px;
      margin-left: 5px;
    }*/
  }

  .right {
    float: right;
    margin: 0.18rem 0.18rem 0 0;

    a {
      display: block;
      height: 0.27rem;
      line-height: 0.27rem;
      border: 1px solid #5dd635;
      /*border-radius: 0.05rem;*/
      color: #5dd635;
      padding: 0 0.066rem 0 0.1rem;
      font-size: 0.15rem;
      width: 0.9rem;
    }
  }

  a {
    display: inline-block;
    color: #323232;
    text-decoration: none;
    background: transparent;
    height: 0.6rem;
    line-height: 0.6rem;
    padding: 0 0.075rem 0 0.1rem;
    font-size: 0.18rem;
    @media screen and (max-width: 760px){
      color: #000;
      font-weight: 400;
    }
  }

  @media screen and (max-width: 760px){
    background: #fff;
    top: 0.51rem;
    bottom: auto;
    /*height: 2.7rem;*/
    .middle {
      display: block;

      div {
        margin: 0;
        line-height: 0.675rem;
        height: 0.675rem;
        float: none;
        display: block;
        /*border-bottom:1px solid #666;*/
      }

      div::after {
        content: '';
      }
    }

    .right {
      float: none;
      display: block;
      border-bottom:1px solid #fff;
      line-height: 0.4rem;
      height: 0.4rem;
      margin: 0;

      a {
        display: inline;
        border:none;
        color: #000;
        padding: 0;
        font-size: 0.14rem
      }
    }
  }
}
.login {
  min-width: 157px;
  height: 48px;
  background: #5ea2ec!important;
  line-height: 48px;
  text-align: center;
  margin-top: .06rem !important;
  border-radius: 25px!important;
  padding: 0 .1rem;
  position: absolute;
  right: 1.5rem;
  top: 0;
  line-height: 48px;
  color: #fff!important;
  font-size: .18rem!important;
  @media screen and (max-width: 1700px) {
    right: .5rem;
  }
  @media screen and (max-width: 760px) {
    display: none !important;
  }
}
.login-box {
  li:nth-child(1) {
      border-bottom: 1px solid #dddddd
    }
  li {
    height: 46px;
    line-height: 46px;
    text-align: center;
    font-size: 18px;
    color: #333;
    cursor: pointer;
  }
}
.location {
  position: absolute;
  right: 380px;
  cursor: pointer;
  top: 20px;
  @media screen and (max-width: 1700px){
    right: 260px;
    @media screen and (max-width: 760px){
      right: 52px;
    }
  }
  span, img {
    vertical-align: middle;
  }
  span {
    margin: 0 30px 0 10px;
    font-size: .18rem;
    @media screen and (max-width: 760px){
      margin: 0 10px 0 5px;
      font-size: .12rem;
    }
  }
  .location-line {
    display: none;
    @media screen and (max-width: 760px){
      display: inline-block;
      vertical-align: middle;
      width: 1px;
      height: 18px;
      background: #323232;
      margin-left: 20px;
    }
  }
}
.my-country-list-leave-active,.my-country-list-enter-active{
  transition:  opacity .5s;
}
.my-country-list-leave-active,.my-country-list-enter{
  opacity: 0;
}
.country-list {
  background: url("../assets/images/20180827/background.png") no-repeat center;
  height: 230px;
  width: 204px;
  padding-top: 27px;
  position: absolute;
  right: 345px;
  top: 40px;
  @media screen and (max-width: 1700px){
    right: 228px;
    @media screen and (max-width: 760px){
      width: 150px;
      right: 23px;
      /*margin-top: 45px;*/
      /*background: url("../assets/images/20180827/background-phone.png") no-repeat center;*/
    }
  }
  li {
    height: 46px;
    line-height: 46px;
    border-bottom: 1px solid #eee;
    padding: 0 20px;
    cursor: pointer;
    width: 98%;
    margin: 0 auto;
    span, img {
      vertical-align: middle;
    }
    span {
      font-size: .18rem;
      margin-left: 10px;
      @media screen and (max-width: 760px){
        font-size: .12rem;
      }
    }
  }
}
</style>
<style>
.el-popover {
  padding: 0!important
}
.el-popper[x-placement^=bottom] .popper__arrow {
  top: -12px;
}
.el-popper .popper__arrow {
  border-width: 12px;
}
.el-popper[x-placement^=bottom] .popper__arrow::after {
  /* left: -12px; */
  /* margin-left: 2px; */
}
.el-popper .popper__arrow::after {
  border-width: 12px;
}
.hover-blue:hover {
  color: #5ea2ec !important;
}
</style>



// WEBPACK FOOTER //
// Nav.vue?fa3a3584